import { create } from "zustand";
import { combine } from "zustand/middleware";

import { sharedTariffStateMutators, TariffData } from "@stores/tariff/utils.ts";

export type LastYearsTariffData = TariffData;

const DEFAULT_LAST_YEARS_TARIFF_DATA: LastYearsTariffData = {
  useTariff: false,
  standingCharge: null,
  exportRate: null,
  tariffPoints: [],
};

export const useLastYearsTariffStore = create(
  combine(DEFAULT_LAST_YEARS_TARIFF_DATA, (set) => ({
    ...sharedTariffStateMutators(set),
  })),
);
